import * as t from '../types';

const initialState = {
    data: '',
    loading: false,
    error: ''
};

export default function mainPdfReducer(state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case t.GET_MAIN_PDF_REQUEST:
            return {
                ...state,
                loading: true
            };
        case t.GET_MAIN_PDF_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload
            };
        case t.GET_MAIN_PDF_FAILED:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
